import { LensOption } from "constants/dataTypes";
import { CategoryLensTypes } from "constants/dataTypes";
import { fixPrice } from "functions/intFixPrice";

export const getProductPricingDescriptionFromLensType = (option: CategoryLensTypes | undefined, locale: string) => {

  if (!option) return '';

  let description = '';
  if (option.price == option.regular_price) {
    if (option.regular_price_max != undefined && option.regular_price < option.regular_price_max) {
      description = '<span class="font-medium">From ' + fixPrice(option.price, locale) + '</span>';
    }
    else {
      description = '<span class="font-medium">' + fixPrice(option.price, locale) + '</span>';
    }
  }
  else {
    //add css for strike through for regular price with tailwindcss
    //to handle discount prices
    description = `<span class="font-medium text-brand-green">${fixPrice(option.price, locale)}</span>  <span style="text-decoration: line-through" class="text-[#959595]"> ${fixPrice(option.regular_price, locale)}</span>`;
  }

  //If there is a price range, add "From" to the description


  return description;
}
export const getProductPricingDescription = (option: LensOption | undefined, locale: string) => {

  if (!option) return '';

  let description = '';
  if (option.price == option.regular_price) {
    description = fixPrice(option.price, locale);
  }
  else {
    //add css for strike through for regular price with tailwindcss
    //to handle discount prices
    description = `<span class="font-medium text-brand-green">${fixPrice(option.price, locale)}</span>  <span style="text-decoration: line-through" class="text-[#959595]"> ${fixPrice(option.regular_price, locale)}</span>`;
  }

  //If there is a price range, add "From" to the description
  if (option.regular_price_max != undefined && option.regular_price < option.regular_price_max) {
    description = "From " + description;
  }

  return description;
}